module.exports = __webpack_public_path__ + "b06c243f534d9c5461d16528156cd5a8.cur";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img/grab.cur
 ** module id = 707
 ** module chunks = 0
 **/